import { PORTAL_PRODUCT_ROLE, SWAGGERHUB_ROLE } from '~/types/portal'
import { Product } from '~/types/product'

export const isAtLeastDesigner = (role?: SWAGGERHUB_ROLE | PORTAL_PRODUCT_ROLE) => role === SWAGGERHUB_ROLE.DESIGNER || role === SWAGGERHUB_ROLE.OWNER

export const isAtLeastConsumer = (role?: SWAGGERHUB_ROLE | PORTAL_PRODUCT_ROLE) => role === SWAGGERHUB_ROLE.CONSUMER || role === SWAGGERHUB_ROLE.DESIGNER || role === SWAGGERHUB_ROLE.OWNER

export const filterAllowedProducts = (
  products: Product[],
  organizationRole?: SWAGGERHUB_ROLE,
  highestRole?: SWAGGERHUB_ROLE,
) => {
  if (isAtLeastDesigner(organizationRole)) {
    return products
  }
  return highestRole === SWAGGERHUB_ROLE.DESIGNER ? products.filter(item => item.role === PORTAL_PRODUCT_ROLE.DESIGNER) : []
}